<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <div class="mbs-wizard_form-content">
    @if (isRDMode && importedPlanChanged) {
      <mbs-alert
        [icon]="true"
        [type]="mbsPopupType.warning">
        {{ 'wizards:whereBackup.where_backup_config_not_supported' | i18next }}
      </mbs-alert>
    }

    <mbs-advanced-options-storage-class-azure-tier
      class="d-block mb-3"
      [accessTires]="advancedOptionsStepLogic.AccessTires"
      [advancedOptionsFlags]="advancedOptionsFlags"
      [parentForm]="stepForm"
      [showAzureTires]="advancedOptionsFlags?.AzureAccessTierType"
      [showStorageClass]="advancedOptionsFlags?.StorageClassSettingPossible && advancedOptionsFlags?.UseS3AccelerationPossible"
      [storageClasses]="advancedOptionsStepLogic.StorageClasses"
      (azureTierChange)="azureAccessTierChangeHandler($event)"
      (storageClassChange)="storageClassChangeHandler($event)"></mbs-advanced-options-storage-class-azure-tier>

    @if (isRDMode && isAzureColdSelected) {
      <mbs-alert
        [attr.data-e2e]="elementSelectors.id.AzureColdWarning"
        [icon]="true"
        [type]="mbsPopupType.info">
        {{ 'wizards:advancedOptions.azureColdWarning' | i18next }}
      </mbs-alert>
    }

    <div [formGroup]="foldersForm">
      <mbs-files-folders
        #fileFoldersComponent
        formControlName="filesFoldersData"
        [params]="{
          showItem: !isRDMode && advancedOptionsFlags?.ExcludePossible,
          dataForPath: getValueForOperationsWithPath(),
          hid: mainService.hid,
          isUnix,
          isNetBuild,
          isEdit,
          isRDMode: isRDMode,
          isOffline: isOffline
        }"></mbs-files-folders>
    </div>

    @if ((!isUnix || isNetBuild) && syntheticFullVisible !== 'Hidden') {
      <mbs-form-group>
        <mbs-checkbox
          formControlName="SyntheticFull"
          [attr.data-e2e]="'synthetic-full-checkbox'"
          [disabledSelf]="syntheticFullVisible === 'Disabled'"
          [label]="'wizards:synthetic_full_label' | i18next"
          [subtitle]="'wizards:synthetic_full_subtitle' | i18next"
          (change)="syntheticFullChangeHandler($event)"></mbs-checkbox>
      </mbs-form-group>
    }

    @if (advancedOptionsFlags?.UseS3AccelerationPossible) {
      <mbs-form-group>
        <mbs-checkbox
          formControlName="UseS3Acceleration"
          [id]="'use-S3-acceleration-checkbox'"
          [label]="'wizards:use_s3_label' | i18next">
          <ng-container appendLabel>
            <span
              class="cursor-help fa fa-info-circle text-info ml-2"
              [ngbTooltip]="'wizards:use_s3_label_tooltip' | i18next"
              [placement]="['right', 'bottom']"></span>
          </ng-container>
        </mbs-checkbox>
      </mbs-form-group>
    }

    @if (advancedOptionsFlags?.IgnoreBadSectorsPossible) {
      <mbs-form-group>
        <mbs-checkbox
          formControlName="IgnoreBadSectors"
          [id]="'ignore-bad-sectors-checkbox'"
          [label]="'wizards:bad_sectors_label' | i18next"></mbs-checkbox>
      </mbs-form-group>
    }

    @if (advancedOptionsFlags?.DisableVSSPossible) {
      <mbs-form-group>
        <mbs-checkbox
          formControlName="DisableVSS"
          [id]="'disable-VSS-checkbox'"
          [label]="'wizards:disable_vss_label' | i18next"></mbs-checkbox>
      </mbs-form-group>
    }

    @if (advancedOptionsFlags?.BackupNTFSPermissionsPossible) {
      <mbs-form-group>
        <mbs-checkbox
          formControlName="BackupNTFSPermissions"
          [id]="elementSelectors.id.BackupNTFSPermissions"
          [label]="'wizards:backup_ntfs_label' | i18next">
        </mbs-checkbox>
      </mbs-form-group>
    }

    @if ((!isUnix || isNetBuild) && !isNBF && isBackupPlan) {
      <mbs-form-group>
        <mbs-checkbox
          formControlName="SaveDeletedDataInCloud"
          [id]="elementSelectors.id.SaveDeletedDataInCloud"
          [label]="'wizards:mark_deleted_label' | i18next"
          (change)="saveDeletedDataInCloudChangeHandler($event)">
          <ng-container appendLabel>
            @if (stepForm.get('SaveDeletedDataInCloud').enabled) {
              <span
                class="cursor-help fa fa-info-circle text-info ml-2"
                [id]="elementSelectors.id.SaveDeletedDataInCloudTooltip"
                [ngbTooltip]="'wizards:mark_deleted_label_tooltip' | i18next"
                [placement]="['bottom-left', 'left', 'auto']"></span>
            }
            @if (stepForm.get('SaveDeletedDataInCloud').disabled) {
              <mbs-wizards-legacy-property-tooltip
                [id]="elementSelectors.id.SaveDeletedDataInCloudLegacyTooltip"></mbs-wizards-legacy-property-tooltip>
            }
          </ng-container>
        </mbs-checkbox>
      </mbs-form-group>
    }

    @if (advancedOptionsFlags?.UseFastNtfsScanPossible) {
      <mbs-form-group>
        <mbs-checkbox
          formControlName="UseFastNtfsScan"
          [id]="'use-fast-ntfs-scan-checkbox'"
          [label]="'wizards:use_ntfs_label' | i18next"
          (change)="useFastNtfsScanChangeHandler($event)">
          <ng-container appendLabel>
            <span
              class="cursor-help fa fa-info-circle text-info ml-2"
              [ngbTooltip]="'wizards:use_ntfs_label_tooltip' | i18next"></span>
          </ng-container>
        </mbs-checkbox>
      </mbs-form-group>
    }

    <mbs-form-group>
      @if (isBackupPlan) {
        @if (advancedOptionsFlags?.AlwaysUseVSSPossible) {
          <ng-container>
            <mbs-checkbox
              formControlName="AlwaysUseVSS"
              [descriptionOutside]="false"
              [id]="'always-use-VSS-provider-checkbox'"
              [label]="'wizards:use_vss_label' | i18next"
              (change)="alwaysUseVSSChangeHandler($event)">
              <ng-container appendLabel>
                <span
                  class="cursor-help fa fa-info-circle text-info ml-2"
                  [ngbTooltip]="'wizards:use_vss_label_tooltip' | i18next"></span>
              </ng-container>
              <ng-template
                checkboxDescription
                [hide]="!advancedOptionsFlags?.UseVSSPossible">
                <mbs-checkbox
                  formControlName="useSystemVSSProvider"
                  [id]="'use-system-VSS-provider-checkbox'"
                  [label]="'wizards:use_system_vss_label' | i18next">
                  <ng-container appendLabel>
                    <span
                      class="cursor-help fa fa-info-circle text-info ml-2"
                      [ngbTooltip]="'wizards:use_system_vss_label_tooltip' | i18next"></span>
                  </ng-container>
                </mbs-checkbox>
              </ng-template>
            </mbs-checkbox>
          </ng-container>
        }
      } @else {
        @if (advancedOptionsFlags?.UseVSSPossible) {
          <ng-container>
            <mbs-checkbox
              formControlName="useSystemVSSProvider"
              [id]="'use-system-VSS-provider-checkbox'"
              [label]="'wizards:use_system_vss_label' | i18next">
              <ng-container appendLabel>
                <span
                  class="cursor-help fa fa-info-circle text-info ml-2"
                  [ngbTooltip]="'wizards:use_system_vss_label_tooltip' | i18next"></span>
              </ng-container>
            </mbs-checkbox>
          </ng-container>
        }
      }
    </mbs-form-group>

    @if (isShowEFS) {
      <mbs-form-group [title]="'wizards:efs_encryption_label' | i18next: { format: 'title' }">
        <mbs-radio
          formControlName="KeepEFSFilesAsIs"
          [id]="'decryptEFS'"
          [label]="'wizards:decrypt_efs_encrypted_files_label' | i18next"
          [value]="false"
          (change)="keepEFSFilesAsIsChangeHandler(false)">
          <ng-container appendLabel>
            <span
              class="cursor-help fa fa-info-circle text-info ml-2"
              [container]="'body'"
              [ngbTooltip]="'wizards:decrypt_efs_encrypted_files_tooltip' | i18next"></span>
          </ng-container>
        </mbs-radio>
        <mbs-radio
          formControlName="KeepEFSFilesAsIs"
          [id]="'KeepAsis'"
          [label]="'wizards:keep_efs_encryption_label' | i18next"
          [value]="true"
          (change)="keepEFSFilesAsIsChangeHandler(true)">
          <ng-container appendLabel>
            <span
              class="cursor-help fa fa-info-circle text-info ml-2"
              tooltipClass="tooltip-lg"
              [container]="'body'"
              [ngbTooltip]="EFSPayAttentionTooltip"></span>
          </ng-container>
        </mbs-radio>
      </mbs-form-group>
    }

    @if (
      !isBackupPlan &&
      (!isNBF || correctlyVersionForShowBlockCount) &&
      (advancedOptionsFlags?.PrefetchBlockCountPossible || advancedOptionsFlags?.BlockSizeSettingPossible)
    ) {
      <ng-container>
        <div class="row">
          <div
            class="col-6"
            [class.col-8]="isNBF || !advancedOptionsFlags?.BlockSizeSettingPossible">
            <mbs-form-group>
              <mbs-number
                formControlName="PrefetchBlockCount"
                [containerClasses]="'w-50'"
                [id]="'prefetch-block-count-input'"
                [label]="'wizards:block_count_label' | i18next"
                [max]="100"
                [min]="0"></mbs-number>
            </mbs-form-group>
          </div>
          <div
            *ngIf="!isNBF && advancedOptionsFlags?.BlockSizeSettingPossible"
            class="col-6">
            <mbs-form-group>
              <label
                class="mbs-form_label"
                [for]="'block-size-select'"
                >{{ 'wizards:block_size_label' | i18next }}</label
              >
              <div class="row">
                <div class="col-6">
                  <mbs-select
                    formControlName="BlockSize"
                    [appendTo]="'.modal-content'"
                    [bindLabel]="'label'"
                    [bindValue]="'value'"
                    [clearable]="false"
                    [id]="'block-size-select'"
                    [items]="blockSizesArray"
                    [searchable]="false"></mbs-select>
                </div>
              </div>
            </mbs-form-group>
          </div>
        </div>
      </ng-container>
    }

    @if (canShowEFSRequiredInfo) {
      <mbs-alert
        class="mb-0"
        [icon]="true"
        [type]="mbsPopupType.info">
        {{ 'wizards:keep_efs_encryption_require_info' | i18next }}
      </mbs-alert>
    }
  </div>
</section>

<ng-template #errorSyntheticFull>
  <p>{{ 'wizards:error_synthetic_text' | i18next }}</p>
  <mbs-alert
    class="mb-0"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:error_synthetic_alert_text' | i18next }}
  </mbs-alert>
</ng-template>

<ng-template #EFSPayAttentionTooltip>
  <dl class="text-start">
    <dd>
      <span>{{ 'wizards:keep_efs_encryption_tooltip' | i18next }}</span>
    </dd>
    <dd>
      <span>{{ 'wizards:keep_efs_encryption_warning_text_1' | i18next }}</span>
    </dd>
    <dd>
      <span>{{ 'wizards:keep_efs_encryption_warning_text_2' | i18next }}</span>
    </dd>
    <dd>
      <ul>
        <li>{{ 'wizards:keep_efs_encryption_warning_action_text_1' | i18next }}</li>
        <li>{{ 'wizards:keep_efs_encryption_warning_action_text_2' | i18next }}</li>
        <li>{{ 'wizards:keep_efs_encryption_warning_action_text_3' | i18next }}</li>
      </ul>
    </dd>
    <dd>
      <span>{{ 'wizards:keep_efs_encryption_warning_text_3' | i18next }}</span>
    </dd>
  </dl>
</ng-template>

<ng-template #EFSPayAttention>
  <mbs-alert
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:keep_efs_encryption_warning_text_1' | i18next }}
  </mbs-alert>
  <strong>{{ 'wizards:keep_efs_encryption_warning_text_2' | i18next }}</strong>
  <ul>
    <li>{{ 'wizards:keep_efs_encryption_warning_action_text_1' | i18next }}</li>
    <li>{{ 'wizards:keep_efs_encryption_warning_action_text_2' | i18next }}</li>
    <li>{{ 'wizards:keep_efs_encryption_warning_action_text_3' | i18next }}</li>
  </ul>
  <p class="mb-0">{{ 'wizards:keep_efs_encryption_warning_text_3' | i18next }}</p>
</ng-template>
